<template>
    <div>
        <v-container class="container-600 overflow-hidden project_header py-0">
            <v-layout v-if="project_detail">
                <div id="properties_items" class="" style="width: 100%;">
                    <v-row class="">
                        <v-col cols="12 mt-5">
<!--                            <h3 :style="'color:'+(project_detail ? getProjectColor(project_detail.project_shortname):'#1976d2')" >{{ project_detail.project_name_th }}</h3>-->
                            <h3 class="text-lpn">{{ project_detail.project_name_th }}</h3>
                        </v-col>
<!--                        <v-col cols="12 mt-0">-->
<!--                            <h3 class="text-lpn">โปรโมชั่น</h3>-->
<!--                        </v-col>-->
                        <v-col cols="12" class="my-0 py-0">
                            <v-card
                                    class="mx-auto my-3"
                                    flat
                                    :id="'project_'+project_detail.project_id"
                            >

                                <div v-if="!slides||slides.length==0" class="text-center">
                                    <img :src="project_detail.prop_image_link" style="width: 100%;max-width: 900px;">
                                </div>
                                <div v-else>
                                    <swiper
                                            class="swiper" ref="projectBannerSlide" :options="swiperOption" style="max-width:700px;"
                                    >

                                        <swiper-slide  v-for="(slide, i) in slides" :key="i">
                                            <img :src="slide.banner_source_url" :alt="slide.banner_name"
                                                 @error="getNotFoundImage($event)"
                                                 style="width: 100%;">
                                        </swiper-slide>

                                        <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                                        <div v-if="(slides&&slides.length>1 ? true:false)" class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                                        <div v-if="(slides&&slides.length>1 ? true:false)"  class="swiper-button-next swiper-button-white" slot="button-next"></div>
                                    </swiper>
                                </div>

                            </v-card>
                        </v-col>
                    </v-row>

                </div>
            </v-layout>
        </v-container>
    </div>

</template>

<script>
    import {Swiper, SwiperSlide} from "vue-awesome-swiper";
    import 'swiper/css/swiper.css'

    export default {
        name: "ProjectPromotionBanner",
        components: {
            Swiper,
            SwiperSlide
        },
        props: {
            project_detail:{type: Object, default: {}},
            banner_list:{type: Array, default: []},
        },
        data() {
            return {
                slides:this.banner_list,
                swiperOption: {
                    spaceBetween: 20,
                    loop: true,
                    speed: 1000,
                    // effect: 'fade',
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                }
            }
        },
        mounted(){
            // this.swiper.slideNext()

            if(this.slides&&this.slides.length<=1){
                this.swiper.autoplay.stop()
                this.swiper.allowTouchMove = false
                // console.log(this.swiper)
            }
        },
        computed: {
            swiper() {
                return this.$refs.projectBannerSlide.$swiper
            }
        },
        methods:{
            getNotFoundImage(event){
                event.target.src = require("@/assets/images/no_image_available.jpeg")
            },
            getBannerUrl(url){
                let src = url
                try {
                    require(src)
                    return src
                } catch (e) {
                    src = require("@/assets/images/no_image_available.jpeg")
                }
                return src
            }
        }
    }
</script>

<style scoped>
    .project_header{
        border-top-right-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }
    .swiper-button-next:after, .swiper-button-prev:after{
        font-size: 1.5em !important;
    }
</style>
